import { SignUp as ExternalSignUp } from '@rockstar/registration-component'
import type { TLang } from 'src/constants/langs'
import { getLanguageBanner } from 'src/constants/languageBanners'
import BgMobile from 'src/icons/BG-mobile-modal.webp'

export const SignUp = ({ language }: { language: TLang }) => {
    const bannerImg = getLanguageBanner(language)
    const bgImg = BgMobile

    return (
        <ExternalSignUp
            language={language}
            banner={bannerImg}
            backgroundImage={bgImg}
        />
    )
}
